import { TP_USERS_LIST, TP_USERS_LIST_FAILD, TP_USERS_LIST_LOADING, ROLE_LIST } from "../type/type";

const initialState = {
    allLeadsData: {
        docs: [],
        totalDocs: 0,
        limit: 0,
        page: 0,
        totalPages: 0,
        pagingCounter: 0,
        hasPrevPage: false,
        hasNextPage: false,
        prevPage: null,
        nextPage: null,
    },
    allLeadsLoading: true,
    loading: false,
    roleList: {
        docs: [],
        totalDocs: 0,
        limit: 0,
        page: 0,
        totalPages: 0,
        pagingCounter: 0,
        hasPrevPage: false,
        hasNextPage: false,
        prevPage: null,
        nextPage: null,
    },
    roleListLoading: true,
};

const subAdminReducers = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case TP_USERS_LIST_LOADING:
            return { ...state, loading: true };
        case TP_USERS_LIST:
            return {
                ...state,
                allLeadsData: {
                    ...state.allLeadsData, // Keep existing structure
                    ...payload, // Update with new API response data
                    page: payload.page || state.allLeadsData.page, // Ensure the page updates correctly
                },
                allLeadsLoading: false,
                loading: false
            };
        case TP_USERS_LIST_FAILD:
            return {
                ...state,
                loading: false,
                allLeadsLoading: false,
            };
        case ROLE_LIST:
            return { ...state, roleListLoading: false, roleList: payload };
        default:
            return state;
    }
};
export default subAdminReducers;